import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '~env/environment';
import { ORDER_STEP_REVIEW_LINK } from '~shared/constants/links.constants';
import { RavelinService } from '~shared/modules/ravelin/services/ravelin.service';

/*
This service might be used to handle more 3ds logic. For that more refactoring needed.
 */
@Injectable()
export class Payment3dsService {
  private waitForFingerprintResults = new BehaviorSubject<boolean>(false);
  waitForFingerprintResults$ = this.waitForFingerprintResults.asObservable();

  constructor() {}

  getReturnUrl() {
    const path = `${environment.baseHref()}${ORDER_STEP_REVIEW_LINK}`;

    return `${window.location.origin}${path.replace('//', '/')}`;
  }

  getReturnUrlByRavelinId(id ?: string){
    const url = this.getReturnUrl();
    if(!id) return url;
    return `${url}?${RavelinService.ROUTER_ID}=${id}`
  }

  setWaitForFingerprintResults(value: boolean): void {
    this.waitForFingerprintResults.next(value);
  }
}
